import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LayoutDashboard, Package, ShoppingBag, Inbox, MessageSquare, Settings, LogOut, FileText, Users } from "lucide-react";

const links = [
  { to: "/admin", label: "Tableau de bord", icon: LayoutDashboard, end: true },
  { to: "/admin/produits", label: "Produits", icon: Package },
  { to: "/admin/commandes", label: "Commandes", icon: ShoppingBag },
  { to: "/admin/precommandes", label: "Précommandes", icon: Inbox },
  { to: "/admin/clients", label: "Clients", icon: Users },
  { to: "/admin/temoignages", label: "Témoignages", icon: MessageSquare },
  { to: "/admin/audit", label: "Journal", icon: FileText },
  { to: "/admin/parametres", label: "Paramètres", icon: Settings },
];

export default function AdminLayout() {
  const { admin, logout, loading } = useAuth();
  const navigate = useNavigate();

  if (loading) return <div className="min-h-screen flex items-center justify-center bg-[#FAF7F0] text-[#6B6B6B]">Chargement...</div>;
  if (!admin) {
    navigate("/admin/login", { replace: true });
    return null;
  }

  const handleLogout = () => {
    logout();
    navigate("/admin/login");
  };

  return (
    <div className="min-h-screen bg-[#FAF7F0] flex">
      <aside className="w-64 border-r border-black/5 bg-white py-8 flex flex-col">
        <div className="px-6 mb-10">
          <div className="text-[#B8860B] text-3xl font-display">✟</div>
          <div className="font-display text-lg text-[#1A1A1A] mt-1">Refuge de la Foi</div>
          <div className="text-[10px] uppercase tracking-[0.3em] text-[#6B6B6B] mt-1">Administration</div>
        </div>
        <nav className="flex-1 px-3 space-y-1">
          {links.map((l) => {
            const Icon = l.icon;
            return (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.end}
                data-testid={`admin-nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-4 py-3 text-sm transition ${
                    isActive
                      ? "bg-[#B8860B]/10 text-[#B8860B] border-l-2 border-[#B8860B]"
                      : "text-[#1A1A1A]/75 hover:text-[#B8860B] border-l-2 border-transparent"
                  }`
                }
              >
                <Icon size={16} strokeWidth={1.5} />
                {l.label}
              </NavLink>
            );
          })}
        </nav>
        <div className="px-6 pt-6 border-t border-black/5">
          <div className="text-xs text-[#6B6B6B] mb-3 truncate">{admin.email}</div>
          <button
            onClick={handleLogout}
            data-testid="admin-logout-btn"
            className="flex items-center gap-2 text-xs uppercase tracking-widest text-[#6B6B6B] hover:text-[#B8860B]"
          >
            <LogOut size={14} /> Déconnexion
          </button>
        </div>
      </aside>
      <main className="flex-1 overflow-y-auto p-8 lg:p-12">
        <Outlet />
      </main>
    </div>
  );
}
